const financialStatementsSelector = (state) =>
  state.financialStatement.financialStatements

export { financialStatementsSelector }
